import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, UntypedFormBuilder } from '@angular/forms';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';

import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { AccountService } from 'app/core';
import { RelatedToType } from 'app/shared/enums';
import { Company } from 'app/modules/companies/companies.types';

@Component({
  selector: 'app-custom-associate-company',
  templateUrl: './custom-associate-company.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomAssociateCompanyComponent extends OnDestroyMixin implements OnInit {
  public isAssociatedCompanySearching: boolean = false;
  public associatedCompanyResults: Company[] | null;
  public associatedCompanyControl = new FormControl('');

  @Output() onValueChanged = new EventEmitter<{ company_name: string }>();
  @Input() readonly: boolean;

  constructor(
    private readonly accountService: AccountService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly formBuilder: UntypedFormBuilder,
  ) {
    super();
  }

  ngOnInit(): void {
    this.searchAssociatedCompany();
  }

  private searchAssociatedCompany(): void {
    this.associatedCompanyControl.valueChanges
      .pipe(
        untilComponentDestroyed(this),
        debounceTime(400),
        distinctUntilChanged(),
        switchMap((value) => {
          this.isAssociatedCompanySearching = !!value;
          return value
            ? this.accountService.typeaheadSearch(value, RelatedToType.Company).pipe(
                untilComponentDestroyed(this),
                map(({ companies }) => companies),
              )
            : of([]);
        }),
      )
      .subscribe((companiesOnlyNames) => {
        this.associatedCompanyResults = companiesOnlyNames;
        this.isAssociatedCompanySearching = false;
        this.cdRef.detectChanges();
      });
  }

  public autocompleteAssociatedCompanySelected(event: MatAutocompleteSelectedEvent): void {
    this.associatedCompanyControl.patchValue(event.option.value, { emitEvent: false });
    this.onValueChanged.emit({ company_name: event.option.value });
  }
}
